<div class="general-container">
  <mat-toolbar>
    <mat-toolbar-row>
      <a [href]="themeService.productSiteUrl">
        <img class="logo-header" [srcset]="themeService.currentVectorLogo" alt="Logo">
      </a>
      <span class="example-spacer"></span>
      <app-multilingual class="multilingual-placement"></app-multilingual>
    </mat-toolbar-row>
  </mat-toolbar>
  <div class="row">
    <div class="titre">
      <b>
        <h3>
          @if (successful) {
            <div>
              {{'REGISTRATION.STEP.PAYMENT.RESULT.SUCCESS' | translate}}
            </div>
          } @else {
            {{'REGISTRATION.STEP.PAYMENT.RESULT.FAILURE' | translate}}
          }
        </h3>
      </b>
    </div>
    <div class="main-frame">
      @if (isLoading()) {
        <div>
          <app-loading></app-loading>
        </div>
      } @else {
        @if (successful) {
          <div>
            <div class="center">
              <mat-icon class="done">done</mat-icon>
              <h4>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.SUCCESS' | translate}}</h4>
              <button mat-raised-button color="primary" class="color-btn buttonClass"
              onclick="location.href='/#/login'">{{'LOGIN.LOGIN_BUTTON' | translate}}</button>
            </div>
          </div>
        } @else {
          <div class="center">
            <mat-icon class="fail">clear</mat-icon>
            <h4>{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.ERROR.MESSAGE' | translate}}</h4>
            <button mat-raised-button color="primary" class="color-btn buttonClass"
              onclick="location.href='/#/subscription'">{{'REGISTRATION.STEP.PAYMENT.DIALOG_PAYMENT.REDIRECT_PAYMENT_PAGE'
            | translate}}</button>
          </div>
        }
      }
    </div>
  </div>
</div>